import axios from 'axios'

const baseURL = process.env.VUE_APP_PRODUCT_SERVICE + '/api/admin/commercial-proposals'

export default {
  namespaced: true,
  state: {
    commercialProposals: [],
    is_loading: false,
    is_processing: false
  },
  mutations: {
    setCommercialProposal (state, templates) {
      state.commercialProposals = templates
    },
    setLoading (state, status) {
      state.is_loading = status
    },
    setProcessing (state, status) {
      state.is_processing = status
    }
  },
  actions: {
    async fetchCommercialProposals ({ commit }) {
      try {
        commit('setLoading', true)
        const response = await axios.get(baseURL)
        commit('setCommercialProposal', response.data)
      } catch (error) {
        console.error(error)
      } finally {
        commit('setLoading', false)
      }
    },
    showCommercialProposal ({ commit }, id) {
      return axios.get(baseURL + '/' + id)
    },
    getStatusCommercialProposal ({ commit }, id) {
      return axios.get(baseURL + '/' + id + '/status')
    },
    async createCommercialProposal ({ commit }, data) {
      commit('setProcessing', true)
      const promise = axios.post(baseURL, data)
      promise.finally(() => {
        commit('setProcessing', false)
      })

      return promise
    },
    async updateCommercialProposal ({ commit }, data) {
      commit('setProcessing', true)
      const promise = axios.put(`${baseURL}/${data.id}`, data)
      promise.finally(() => {
        commit('setProcessing', false)
      })

      return promise
    },
    async addProductsCommercialProposal ({ commit }, data) {
      return axios.put(`${baseURL}/${data.id}/add-products`, { ids: data.ids })
    },
    async deleteCommercialProposal ({ commit }, id) {
      commit('setProcessing', true)
      const promise = axios.delete(`${baseURL}/${id}`)
      promise.finally(() => {
        commit('setProcessing', false)
      })

      return promise
    }
  }
}
